// src/data/grammarQuestions/businessEmail3Questions.js
export const businessEmail3Questions = [
  {
    id: 1,
    koreanQuestion:
      "수석 프로젝트 매니저로서 NextVision Technologies의, 저는 (현재) 가졌습니다 즐거움을 일하는  _____  Emily와 지난 3년 동안",
    question:
      "As a Senior Project Manager at NextVision Technologies, I have had the pleasure of working _____ with Emily over the past three years.",
    choices: {
      A: "closely",
      B: "hardly",
      C: "lately",
      D: "shortly",
    },
    correctAnswer: "A",
    explanation:
      "A: 긴밀하게 B: 거의 ~않게 C: 최근에 D: 짧게 / 'working closely with someone'은 '누군가와 긴밀하게 협력하다'라는 의미로, 추천서나 비즈니스 이메일에서 동료와의 협력 관계를 설명할 때 자주 사용되는 표현입니다. 따라서 'closely'가 가장 적절한 선택입니다.",
    translation:
      "NextVision Technologies의 수석 프로젝트 매니저로서, 저는 지난 3년 동안 Emily와 긴밀하게 일하는 즐거움을 가졌습니다.",
    type: "business email",
  },
  {
    id: 2,
    koreanQuestion:
      "그것은 특권이었습니다 일하는 가깝게 에밀리와 이 기간 동안, 그리고 저는 의심하지 않습니다 그..  그녀가 탁월한 ____이 될거라는 것을 귀하의 팀에.",
    question:
      "It has been a privilege to work closely with Emily during this time, and I do not doubt that she will be an outstanding _______ to your team.",
    choices: {
      A: "addition",
      B: "donate",
      C: "perform",
      D: "instruct",
    },
    correctAnswer: "A",
    explanation:
      "A: 추가, 영입 B: 기부하다 C: 수행하다 D: 지시하다 / 'addition to your team'은 '팀에 새로운 구성원이 추가됨'을 의미하는 표현으로, 추천서에서 누군가가 새 팀에 합류하여 가치를 더할 것이라는 맥락에서 'addition'이 가장 적절한 선택입니다. 다른 선택지들은 문맥상 적합하지 않습니다.",
    translation:
      "이 기간 동안 Emily와 긴밀하게 일하는 것은 특권이었으며, 그녀가 귀하의 팀에 탁월한 영입이 될 것이라는 것을 의심하지 않습니다.",
    type: "business email",
  },
  {
    id: 3,
    koreanQuestion:
      "그녀의 의사소통 능력, 서면과 ______ 모두, 탁월합니다, 그녀는 가집니다 타고난 능력 제시하는 복잡한 아이디어를 이해하기 쉽고 흥미로운 방식으로.",
    question:
      "Her communication skills, both written and ______, are exceptional, and she has a natural ability to present complex ideas in an accessible and engaging manner.",
    choices: {
      A: "verbally",
      B: "verbal",
      C: "verb",
      D: "verbalize",
    },
    correctAnswer: "B",
    explanation:
      "A: 구두로 B: 구두의 C: 동사 D: 말로 표현하다 / 'both written and verbal'은 '서면과 구두 모두'라는 의미로, 의사소통 능력의 두 가지 형태를 나열할 때 사용됩니다. 'written'이 형용사 형태이므로, 병렬 구조를 위해 형용사인 'verbal'이 가장 적절합니다.",
    translation:
      "그녀의 의사소통 능력은 서면과 구두 모두 탁월하며, 복잡한 아이디어를 이해하기 쉽고 흥미로운 방식으로 제시하는 타고난 능력을 가지고 있습니다.",
    type: "business email",
  },
  {
    id: 4,
    koreanQuestion:
      "최전선에서부터 무대 뒤까지, 여러분 각자는 했습니다 _____ 역할을 도달하는데 이 이정표에",
    question:
      "From frontline to behind-the-scenes, each of you has played a ______ role in reaching this milestone.",
    choices: {
      A: "vitality",
      B: "vital",
      C: "vitally",
      D: "vitalize",
    },
    correctAnswer: "B",
    explanation:
      "A: 활력 B: 중요한, 필수적인 C: 매우 중요하게 D: 활기를 불어넣다 / 'play a vital role'은 '중요한 역할을 하다'라는 의미의 일반적인 표현입니다. 여기서는 형용사가 명사 'role'을 수식해야 하므로, 형용사인 'vital'이 가장 적절합니다. 'vitality'는 명사, 'vitally'는 부사, 'vitalize'는 동사로 문맥상 적합하지 않습니다.",
    translation:
      "최전선에서부터 무대 뒤까지, 여러분 각자는 이 이정표에 도달하는 데 중요한 역할을 했습니다.",
    type: "business email",
  },
  {
    id: 5,
    koreanQuestion:
      "안전 고글은 반드시 보관되어야 합니다 구급상자와 소화기사이에",
    question:
      "The safety goggles must be stored _____ the first-aid kit and the fire extinguisher.",
    choices: {
      A: "among",
      B: "between",
      C: "under",
      D: "beside",
    },
    correctAnswer: "B",
    explanation:
      "A: ~중에서 B: ~사이에 C: ~아래에 D: ~옆에 / '두 물체 사이에'라는 의미를 나타낼 때는 'between'을 사용합니다. 여기서는 구급상자와 소화기 사이에 안전 고글을 보관해야 한다는 의미이므로 'between'이 가장 적절합니다. 'among'은 셋 이상의 물체 사이에 있을 때 사용하고, 'under'와 'beside'는 위치 관계가 다릅니다.",
    translation:
      "안전 고글은 반드시 구급상자와 소화기 사이에 보관되어야 합니다.",
    type: "business email",
  },
  {
    id: 6,
    koreanQuestion:
      "알려주세요 ____ 시간 그리고 날짜를 귀하에게 가능한, 그리고 저는 맞출 수 있을 것입니다.",
    question:
      "Please let me know a ______ time and date that works for you, and I will be happy to accommodate.",
    choices: {
      A: "suitable",
      B: "temporary",
      C: "confident",
      D: "narrow",
    },
    correctAnswer: "A",
    explanation:
      "A: 적합한 B: 임시의 C: 자신감 있는 D: 좁은 / 'suitable time and date'는 '적합한 시간과 날짜'를 의미합니다. 이 문맥에서는 상대방에게 자신에게 맞는 시간과 날짜를 알려달라고 요청하는 것이므로, '적합한'이라는 의미의 'suitable'이 가장 적절합니다. 'temporary'(임시의), 'confident'(자신감 있는), 'narrow'(좁은)는 시간과 날짜를 묘사하는 데 적합하지 않습니다.",
    translation:
      "귀하께서 가능한 시간과 날짜를 알려주시면 기꺼이 맞추도록 하겠습니다.",
    type: "business email",
  },
  {
    id: 7,
    koreanQuestion:
      "위원회는 (현재) 상담 중입니다. 자문위원들과 Apex Consulting으로부터, 그... ______ (현재) 작성했던 예비 보고서를.",
    question:
      "The committee is consulting with advisors from Apex Consulting, which ____ have drafted the preliminary report.",
    choices: {
      A: "them",
      B: "themselves",
      C: "their",
      D: "they",
    },
    correctAnswer: "D",
    explanation:
      "A: 그들을 B: 그들 자신 C: 그들의 D: 그들이 / 관계대명사 'which' 다음에 오는 절에서는 주어가 필요합니다. 여기서는 'advisors from Apex Consulting'를 지칭하는 주어가 필요하므로, 주격 대명사인 'they'가 가장 적절합니다. 'them'은 목적격, 'themselves'는 재귀대명사, 'their'은 소유격으로 주어 위치에 올 수 없습니다.",
    translation:
      "위원회는 Apex Consulting의 자문위원들과 상담 중이며, 그들이 예비 보고서를 작성했습니다.",
    type: "business email",
  },
  {
    id: 8,
    koreanQuestion:
      "우리는 믿습니다 이 제품이 원할히 통합될 수 있다고 귀사의 운영안에 그리고 잠재적으로 향상시킬 수 있다고 생산성을.",
    question:
      "We believe this product can seamlessly integrate ___ your operations and potentially enhance productivity.",
    choices: {
      A: "into",
      B: "onto",
      C: "over",
      D: "across",
    },
    correctAnswer: "A",
    explanation:
      "A: ~안으로 B: ~위에 C: ~위에, ~너머에 D: ~을 가로질러 / 'integrate into'는 '~에 통합되다'라는 의미로, 무언가가 다른 것의 일부가 되는 것을 나타냅니다. 이 문맥에서는 제품이 운영에 통합된다는 의미이므로 'into'가 가장 적절합니다. 'onto'(~위에), 'over'(~위에, ~너머에), 'across'(~을 가로질러)는 통합의 개념을 정확하게 표현하지 못합니다.",
    translation:
      "저희는 이 제품이 귀사의 운영에 원활하게 통합되어 잠재적으로 생산성을 향상시킬 수 있다고 믿습니다.",
    type: "business email",
  },
  {
    id: 9,
    koreanQuestion:
      "온라인 소매업체는 제휴했습니다 물류 회사 GlobalShip과, 그.... ____ 제공합니다 익일 배송을 전국적으로.",
    question:
      "The online retailer partnered with logistics firm GlobalShip, which ____ provides next-day delivery nationwide.",
    choices: {
      A: "them",
      B: "themselves",
      C: "their",
      D: "they",
    },
    correctAnswer: "D",
    explanation:
      "A: 그들을 B: 그들 자신 C: 그들의 D: 그들이 / 관계대명사 'which' 다음에 오는 절에서는 주어가 필요합니다. 여기서는 'GlobalShip'을 지칭하는 주어가 필요하므로, 주격 대명사인 'they'가 가장 적절합니다. 'them'은 목적격, 'themselves'는 재귀대명사, 'their'은 소유격으로 주어 위치에 올 수 없습니다.",
    translation:
      "온라인 소매업체는 물류 회사 GlobalShip과 제휴했으며, 그 회사는 전국적으로 익일 배송을 제공합니다.",
    type: "business email",
  },
  {
    id: 10,
    koreanQuestion:
      "프로젝트 헌장은 승인되었습니다 경영진에 의해, 그... ____ 권한을 부여합니다 팀이 시작할 수 있도록 작업을 즉시.",
    question:
      "The project charter was approved by management, which ______ authorizes the team to begin work immediately.",
    choices: {
      A: "they",
      B: "it",
      C: "its",
      D: "them",
    },
    correctAnswer: "B",
    explanation:
      "A: 그들이 B: 그것이 C: 그것의 D: 그들을 / 관계대명사 'which' 다음에 오는 절에서는 주어가 필요합니다. 여기서는 'project charter'를 지칭하는 주어가 필요하므로, 단수 주격 대명사인 'it'이 가장 적절합니다. 'they'와 'them'은 복수형이므로 단수인 'project charter'를 지칭할 수 없으며, 'its'는 소유격으로 주어 위치에 올 수 없습니다.",
    translation:
      "프로젝트 헌장은 경영진에 의해 승인되었으며, 그것은 팀이 즉시 작업을 시작할 수 있도록 권한을 부여합니다.",
    type: "business email",
  },
  {
    id: 11,
    koreanQuestion:
      "당신이 요구한다면 어떤 ____ 설명을, 언제든지 답장 해주세요 이 이메일에",
    question:
      "Should you require any ______ clarifications, please feel free to reply to this email.",
    choices: {
      A: "immediate",
      B: "temporary",
      C: "distant",
      D: "monthly",
    },
    correctAnswer: "A",
    explanation:
      "A: 즉각적인 B: 일시적인 C: 먼, 원거리의 D: 월간의 / 이 문맥에서는 '즉각적인 명확한 설명'이 가장 적절합니다. 비즈니스 이메일에서 질문이나 의문사항에 대해 즉시 답변을 제공하겠다는 의미를 전달합니다. 'temporary'(일시적인), 'distant'(먼, 원거리의), 'monthly'(월간의)는 '명확한 설명'과 함께 사용하기에 의미상 적절하지 않습니다.",
    translation:
      "즉각적인 명확한 설명이 필요하시면 언제든지 이 이메일에 답장을 주시기 바랍니다.",
    type: "business email",
  },
  {
    id: 12,
    koreanQuestion:
      "우리는 _____ 기대합니다 기회를 소개할 이 제품을 당신에게 자세히 그리고 설명할 이 제품의 잠재적 이점들을 당신의 귀사를 위해서.",
    question:
      "We are ______ looking forward to the opportunity to present this product to you in detail and illustrate its prospective benefits for your company.",
    choices: {
      A: "eagerly",
      B: "heavily",
      C: "randomly",
      D: "loudly",
    },
    correctAnswer: "A",
    explanation:
      "A: 간절히, 열심히 B: 심하게 C: 무작위로 D: 시끄럽게 / 'look forward to'(기대하다)와 함께 사용할 때 'eagerly'(간절히, 열심히)가 가장 자연스럽습니다. 비즈니스 이메일에서 제품 소개에 대한 긍정적인 기대감을 표현하는 데 적합합니다. 'heavily'(심하게), 'randomly'(무작위로), 'loudly'(시끄럽게)는 이 맥락에서 의미적으로 적절하지 않습니다.",
    translation:
      "우리는 이 제품을 상세히 소개하고 귀사에 대한 잠재적 이점을 설명할 기회를 간절히 기대하고 있습니다.",
    type: "business email",
  },
  {
    id: 13,
    koreanQuestion:
      "Mi-52는 제품입니다 제작된 우수성을 위해, 고급 기능과 함께 돕기 위한 원할한 운영을, 제공하며 종합적인 솔루션을 더 나운 생산성을 위해 그리고 성능을 위해",
    question:
      "The Mi-52 is a product crafted for excellence, with advanced features to aid ___ seamless operations, providing holistic solutions for better productivity and performance.",
    choices: {
      A: "in",
      B: "on",
      C: "at",
      D: "by",
    },
    correctAnswer: "A",
    explanation:
      "A: ~에서, ~안에 B: ~위에 C: ~에서(특정 장소나 시간) D: ~에 의해 / 'aid in'은 '~에 도움을 주다'라는 의미의 관용구입니다. 'aid in something'의 형태로 사용되며, 여기서는 'aid in seamless operations'(원활한 운영에 도움을 주다)가 문법적으로 올바른 표현입니다. 다른 전치사들은 이 맥락에서 적절하지 않습니다.",
    translation:
      "Mi-52는 우수성을 위해 제작된 제품으로, 더 나은 생산성과 성능을 위한 종합적인 솔루션을 제공하며 원활한 운영을 지원하는 고급 기능을 갖추고 있습니다.",
    type: "business email",
  },
  {
    id: 14,
    koreanQuestion:
      "직원들 그.. 계획하는 가질 무급 휴가를 _____ 해야 합니다 그들의 관리자에게 최소 한 달 시작일 전에.",
    question:
      "Employees who plan to take unpaid leave should ______ their manager at least one month before the start date.",
    choices: {
      A: "inform",
      B: "informed",
      C: "informing",
      D: "informs",
    },
    correctAnswer: "A",
    explanation:
      "A: 알리다(동사 원형) B: 알린(과거분사) C: 알리는(현재분사) D: 알린다(3인칭 단수 현재형) / 'should' 조동사 뒤에는 동사 원형이 와야 합니다. 따라서 'inform'이 문법적으로 올바른 선택입니다. 'should informed'는 문법적으로 맞지 않으며, 'informing'과 'informs'도 이 문맥에서는 적절하지 않습니다.",
    translation:
      "무급 휴가를 계획하는 직원들은 시작일로부터 최소 한 달 전에 그들의 관리자에게 알려야 합니다.",
    type: "business email",
  },
  {
    id: 15,
    koreanQuestion:
      "안나 리는 졸업했습니다 최고성적으로 그녀의 학급에서 그리고 즉시 고용되었습니다 _____ 컨설팅 회사에.",
    question:
      "Anna Lee graduated at the top of her cohort and was promptly hired by a ______ consulting firm.",
    choices: {
      A: "communicative",
      B: "reputable",
      C: "successive",
      D: "sustainable",
    },
    correctAnswer: "B",
    explanation:
      "A: 의사소통이 원활한 B: 평판이 좋은, 명성 있는 C: 연속적인 D: 지속 가능한 / 'reputable'(평판이 좋은, 명성 있는)이 컨설팅 회사를 설명하는 데 가장 적합합니다. 우수한 학생이 고용될 만한 회사는 '평판이 좋은' 회사일 가능성이 높습니다. 'communicative'(의사소통이 원활한), 'successive'(연속적인), 'sustainable'(지속 가능한)은 이 맥락에서 덜 적절합니다.",
    translation:
      "안나 리는 그녀의 학급에서 최고 성적으로 졸업했고 즉시 평판이 좋은 컨설팅 회사에 고용되었습니다.",
    type: "business email",
  },
  {
    id: 16,
    koreanQuestion:
      "워크샵은 무료입니다 그리고 열려있습니다 모두에게, 그래서 등록비도, 참가비도 필요하지 않습니다.",
    question:
      "The workshop is free and open to all, so neither registration fee _____ attendance fee is required.",
    choices: {
      A: "and",
      B: "but",
      C: "nor",
      D: "or",
    },
    correctAnswer: "C",
    explanation:
      "A: 그리고 B: 그러나 C: ~도 아니다 D: 또는 / 'neither A nor B'는 'A도 B도 아니다'라는 의미의 상관접속사입니다. 'neither'와 함께 사용될 때는 'nor'가 문법적으로 올바른 선택입니다. 'neither... and', 'neither... but', 'neither... or'는 문법적으로 맞지 않습니다.",
    translation:
      "워크샵은 무료이며 모든 사람에게 열려 있으므로, 등록비도 참가비도 필요하지 않습니다.",
    type: "business email",
  },
  {
    id: 17,
    koreanQuestion:
      "감사가 드러냈을 때 여러 규정 준수 문제를, 이사회는 결정했다 수정하기로 회사의 행동 강령을.",
    question:
      "_______ the audit revealed multiple compliance issues, the board decided to revise the company's code of conduct.",
    choices: {
      A: "While",
      B: "Since",
      C: "Unless",
      D: "Despite",
    },
    correctAnswer: "B",
    explanation:
      "A: ~하는 동안, ~인 반면에 B: ~이후로, ~때문에 C: ~하지 않는 한 D: ~에도 불구하고. 여기서는 'Since'가 정답입니다. 'Since'는 '~때문에'라는 의미로, 감사에서 규정 준수 문제가 발견되었기 때문에 이사회가 행동 강령을 수정하기로 결정했다는 인과 관계를 나타냅니다.",
    translation:
      "감사에서 여러 규정 준수 문제가 드러났기 때문에, 이사회는 회사의 행동 강령을 수정하기로 결정했습니다.",
    type: "business email",
  },
  {
    id: 18,
    koreanQuestion:
      "고려한 후 모든 옵션들을, 제임스는 결정했다 그... ___ 상점을 하루 동안 하기 위해 연례 재고조사를 일으킬 수 있다 가장 적은 방해를 고객들에게.",
    question:
      "After considering all the options, James decided that ______ the store a day to do the annual inventory would cause the least amount of disturbance for customers.",
    choices: {
      A: "close",
      B: "closing",
      C: "closed",
      D: "to closing",
    },
    correctAnswer: "B",
    explanation: "결정했다 닫는 것을 상점을 ",
    translation:
      "모든 옵션을 고려한 후, 제임스는 연례 재고조사를 위해 상점을 하루 동안 닫는 것이 고객들에게 가장 적은 방해를 줄 것이라고 결정했습니다.",
    type: "business email",
  },
  {
    id: 19,
    koreanQuestion:
      "위원회는 신중하게 ______ 컨설턴트들의 추천사항들을 변경하기 전에 휴가 정책을 직원 매뉴얼안의.",
    question:
      "The committee carefully ______ the consultants' recommendations before changing the vacation policy in the employee manual.",
    choices: {
      A: "examine",
      B: "was examined",
      C: "examined",
      D: "examining",
    },
    correctAnswer: "C",
    explanation:
      "A: 검토하다(동사 원형) B: 검토되었다(수동태) C: 검토했다(과거형) D: 검토하는(현재분사) / 이 문장에서는 과거 시제가 필요하므로 'examined'가 정답입니다. 위원회가 과거에 컨설턴트의 추천사항을 신중하게 검토했다는 의미입니다.",
    translation:
      "위원회는 직원 매뉴얼의 휴가 정책을 변경하기 전에 컨설턴트들의 추천사항들을 신중하게 검토했습니다.",
    type: "business email",
  },
  {
    id: 20,
    koreanQuestion:
      "테크노바는 찾고 있습니다 회계사를 그.. 지식이 국제 세금 규정 필수적인.",
    question:
      "TechNova is seeking accountants _____ knowledge of international tax regulations is essential.",
    choices: {
      A: "whom",
      B: "which",
      C: "whose",
      D: "who",
    },
    correctAnswer: "C",
    explanation:
      "A: 목적격 관계대명사(사람) B: 주격/목적격 관계대명사(사물) C: 소유격 관계대명사(사람/사물) D: 주격 관계대명사(사람) / '…의 지식이 필수적인' 의미로, 소유격 관계대명사 whose가 와야 합니다.",
    translation:
      "테크노바는 국제 세금 규정에 대한 지식이 필수적인 회계사를 찾고 있습니다.",
    type: "business email",
  },
  {
    id: 21,
    koreanQuestion:
      "컨설턴트 그 ... 우리가 고용한 작년에 (현재) 이미 완료했습니다 감사 보고서를.",
    question:
      "The consultant ____ we hired last year has already completed the audit report.",
    choices: {
      A: "which",
      B: "whom",
      C: "who",
      D: "whose",
    },
    correctAnswer: "B",
    explanation:
      "A: 관계대명사(사물) B: 목적격 관계대명사(사람) C: 주격 관계대명사(사람) D: 소유격 관계대명사(사람/사물) / 이 문장에서는 'we hired'의 목적어 역할을 하는 관계대명사가 필요합니다. 컨설턴트는 사람이므로 사람을 지칭하는 목적격 관계대명사 'whom'이 정답입니다. 'The consultant whom we hired'는 '우리가 고용한 컨설턴트'라는 의미입니다.",
    translation:
      "우리가 작년에 고용한 컨설턴트는 이미 감사 보고서를 완료했습니다.",
    type: "business email",
  },
  {
    id: 22,
    koreanQuestion:
      "채용 패널은 검토했습니다 지원자들을 그... 배경이 재생 에너지 분야 일치하는 프로젝트 요구사항과.",
    question:
      "The hiring panel reviewed applicants ______ background in renewable energy matched the project requirements.",
    choices: {
      A: "whom",
      B: "which",
      C: "whose",
      D: "who",
    },
    correctAnswer: "C",
    explanation:
      "A: 목적격 관계대명사(사람) B: 주격/목적격 관계대명사(사물) C: 소유격 관계대명사(사람/사물) D: 주격 관계대명사(사람) / 이 문장에서는 '지원자들의 배경'을 나타내는 소유격 관계대명사가 필요합니다. 'whose background'는 '~의 배경'이라는 의미로, 소유격 관계대명사 'whose'가 정답입니다.",
    translation:
      "채용 패널은 재생 에너지 분야의 배경이 프로젝트 요구사항과 일치하는 지원자들을 검토했습니다.",
    type: "business email",
  },
  {
    id: 23,
    koreanQuestion:
      "첨부파일 그.. 보내진 매니저에게 어제 포함되어 있습니다 정보가 ______ 마케팅 분석 보고서에 마케팅 부서에 의한.",
    question:
      "The attachment that was sent to the manager yesterday contained information ______ to the marketing analysis report by the marketing department.",
    choices: {
      A: "addition",
      B: "adds",
      C: "added",
      D: "adding",
    },
    correctAnswer: "C",
    explanation:
      "A: 추가 (명사) B: 추가하다 (동사 현재형) C: 추가된 (과거분사) D: 추가하는 (현재분사) / 이 문장에서는 'information'을 수식하는 과거분사가 필요합니다. 'information added to the report'는 '보고서에 추가된 정보'라는 의미로, 과거분사 'added'가 정답입니다.",
    translation:
      "어제 매니저에게 보낸 첨부 파일에는 마케팅 부서의 마케팅 분석 보고서에 추가된 정보가 포함되어 있었습니다.",
    type: "business email",
  },
  {
    id: 24,
    koreanQuestion:
      "안전 프로토콜이 ______ 시행되었습니다 이끌며 수많은 규정 준수 문제들을.",
    question:
      "The safety protocols were ______ implemented, leading to numerous compliance issues.",
    choices: {
      A: "adequately",
      B: "inaccurately",
      C: "inadequately",
      D: "consistently",
    },
    correctAnswer: "C",
    explanation:
      "A: 적절하게 B: 부정확하게 C: 불충분하게 D: 일관되게 / 이 문장에서는 '규정 준수 문제가 발생했다'는 결과로 보아, 안전 프로토콜이 '불충분하게' 시행되었음을 알 수 있습니다. 따라서 'inadequately'(불충분하게)가 정답입니다.",
    translation:
      "안전 프로토콜이 불충분하게 시행되어 수많은 규정 준수 문제가 발생했습니다.",
    type: "business email",
  },
  {
    id: 25,
    koreanQuestion:
      "제안서는 _____ 작성되었습니다 충족하기 위해 고객의 엄격한 지침을.",
    question:
      "The proposal was ______ drafted to meet the client's strict guidelines.",
    choices: {
      A: "meticulously",
      B: "hastily",
      C: "rarely",
      D: "silently",
    },
    correctAnswer: "A",
    explanation:
      "A: 꼼꼼하게, 세심하게 B: 서둘러, 급하게 C: 드물게 D: 조용히 / 이 문장에서는 '고객의 엄격한 지침을 충족하기 위해' 제안서가 어떻게 작성되었는지를 나타내는 부사가 필요합니다. '꼼꼼하게, 세심하게'라는 의미의 'meticulously'가 가장 적절합니다.",
    translation:
      "제안서는 고객의 엄격한 지침을 충족하기 위해 꼼꼼하게 작성되었습니다.",
    type: "business email",
  },
  {
    id: 26,
    koreanQuestion:
      "새 소프트웨어는 _____ 테스트되었습니다 출시 전에, 결과를 내며 최소한의 버그만.",
    question:
      "The new software was ______ tested before release, resulting in minimal bugs.",
    choices: {
      A: "thoroughly",
      B: "hardly",
      C: "brightly",
      D: "abruptly",
    },
    correctAnswer: "A",
    explanation:
      "A: 철저히 B: 거의 ~않게 C: 밝게 D: 갑자기 / 이 문장에서는 '최소한의 버그만 발생했다'는 결과로 보아, 소프트웨어가 '철저히' 테스트되었음을 알 수 있습니다. 따라서 'thoroughly'(철저히)가 정답입니다.",
    translation:
      "새 소프트웨어는 출시 전에 철저히 테스트되어 최소한의 버그만 발생했습니다.",
    type: "business email",
  },
  {
    id: 27,
    koreanQuestion:
      " _____ 교육 방법과 달리, 우리의 새로운 프로그램은 맞춥니다 각 학습자의 속도에 맞게.",
    question:
      "Unlike _____ training methods, our new program adapts to each learner's pace.",
    choices: {
      A: "traditional",
      B: "technical",
      C: "tentative",
      D: "transitional",
    },
    correctAnswer: "A",
    explanation:
      "A: 전통적인 B: 기술적인 C: 시험적인, 임시적인 D: 과도기적인 / 이 문장에서는 '우리의 새로운 프로그램'과 대조되는 교육 방법을 설명하는 형용사가 필요합니다. '전통적인'이라는 의미의 'traditional'이 가장 적절합니다.",
    translation:
      "전통적인 교육 방법과 달리, 우리의 새로운 프로그램은 각 학습자의 속도에 맞게 조정됩니다.",
    type: "business email",
  },
  {
    id: 28,
    koreanQuestion:
      "모든 고객 불만 사항은 (현재) _____ 처리되었습니다 24시간 이내에.",
    question:
      "All customer complaints have been ______ addressed within 24 hours.",
    choices: {
      A: "promptly",
      B: "loosely",
      C: "boldly",
      D: "rarely",
    },
    correctAnswer: "A",
    explanation:
      "A: 신속하게 B: 느슨하게 C: 대담하게 D: 드물게 / 이 문장에서는 '24시간 이내에' 고객 불만 사항이 어떻게 처리되었는지를 나타내는 부사가 필요합니다. '신속하게'라는 의미의 'promptly'가 가장 적절합니다.",
    translation: "모든 고객 불만 사항은 24시간 이내에 신속하게 처리되었습니다.",
    type: "business email",
  },
  {
    id: 29,
    koreanQuestion: "마케팅 예산은 _____ 할당되었습니다 모든 지역 사무소에.",
    question:
      "The marketing budget was ______ allocated across all regional offices.",
    choices: {
      A: "evenly",
      B: "narrowly",
      C: "brightly",
      D: "silently",
    },
    correctAnswer: "A",
    explanation:
      "A: 고르게, 균등하게 B: 좁게 C: 밝게 D: 조용히 / 이 문장에서는 '모든 지역 사무소에' 마케팅 예산이 어떻게 할당되었는지를 나타내는 부사가 필요합니다. '고르게, 균등하게'라는 의미의 'evenly'가 가장 적절합니다.",
    translation: "마케팅 예산은 모든 지역 사무소에 균등하게 할당되었습니다.",
    type: "business email",
  },
  {
    id: 30,
    koreanQuestion:
      "인사 정책은 이제 지원합니다 원격 근무를, _____ 지침과는 대조적으로 그...요구하는 매일 사무실 출근을.",
    question:
      "The HR policy now supports remote work, in contrast to ________ guidelines requiring daily office attendance.",
    choices: {
      A: "outdated",
      B: "outstanding",
      C: "operational",
      D: "occasional",
    },
    correctAnswer: "A",
    explanation:
      "A: 구식의, 시대에 뒤떨어진 B: 뛰어난, 미결제의 C: 운영상의 D: 가끔의 / 이 문장에서는 '매일 사무실 출근을 요구하는' 지침을 설명하는 형용사가 필요합니다. 원격 근무를 지원하는 새로운 정책과 대조되므로 '구식의, 시대에 뒤떨어진'이라는 의미의 'outdated'가 가장 적절합니다.",
    translation:
      "인사 정책은 이제 원격 근무를 지원합니다, 매일 사무실 출근을 요구하는 구식 지침과는 대조적으로.",
    type: "business email",
  },
];
